
import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

export default [
    {
        id: 'billing_no',
        name: 'billing_no',
        title: i18n.t('Billing No.'),
        filterable: false,
        togglable: true,
    },
    {
        id: 'bank',
        name: 'bank_name',
        title: i18n.t('Bank'),
        filterable: false,
        togglable: true,
    },
    {
        id: 'quantity_parc',
        name: 'quantity_parc',
        title: i18n.t('Number of parcels'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'total_amount',
        name: 'total_amount',
        title: i18n.t('Amount pending transfer'),
        filterable: true,
        togglable: true,
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'create_date',
        name: 'create_date',
        title: i18n.t('Execution date'),
        filterable: true,
        togglable: true,
        width:'150px',
        formatter: (data) => {
            return convertTimezone.utcToLocal(data);
        }
    },
    {
        id: 'action',
        name: 'action',
        title: i18n.t('Action'),
        filterable: true,
        togglable: true,
        width:'150px',
    }
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/cod_fields_waiting.js